//@flow
import type { Action, Reducer } from '../../core/types'

type ActionHandlers = {
  [actionType: string]: (state: Object, action: Action) => Object
}
export function buildReducer(
  initialState: any,
  handlers: ActionHandlers
): Reducer {
  return (state: Object = initialState, action: Action) => {
    const handler = handlers[action.type]
    if (!handler) return state
    return handler(state, action)
  }
}



// WEBPACK FOOTER //
// ./src/modules/lib/buildReducer.js